var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "c-uploader-main",
      attrs: { ondragover: "this.__onDragOver" }
    },
    [
      _c("input", {
        ref: "file",
        staticStyle: { display: "none" },
        attrs: { type: "file", name: "files", multiple: "multiple" },
        on: { change: _vm.__add }
      }),
      _vm._v(" "),
      _c("v-text-field", {
        ref: "folder",
        staticStyle: { display: "none" },
        attrs: { onchange: "__add(e)" }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "c-uploader-dnd",
          class: this.dnd ? "c-uploader-dnd-over" : "",
          on: {
            click: function($event) {
              return _vm.triggerFileSelect("files")
            },
            dragover: _vm.uploadDragOver,
            drop: _vm.onDrop
          }
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "c-uploader-dnd-text" }, [
            _vm._v("Browse files to upload")
          ])
        ]
      ),
      _vm._v(" "),
      _vm.totalAdded && !_vm.readingFiles && _vm.files.length
        ? _c("div", { staticClass: "c-uploader-status-bar" }, [
            this.files.length
              ? _c(
                  "div",
                  { staticClass: "c-uploader-files" },
                  _vm._l(this.files, function(file) {
                    return _c(
                      "div",
                      { key: file.name },
                      [
                        _c("CFile", {
                          attrs: {
                            uploadInProgress: _vm.getUploadInProgress,
                            file: file
                          },
                          on: { onRemove: _vm.__remove }
                        })
                      ],
                      1
                    )
                  }),
                  0
                )
              : _vm._e()
          ])
        : this.readingFiles
        ? _c("div", { staticClass: "c-uploader-loading" }, [
            _vm._v("Your files are being read")
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "margin-bottom": "8px" } }, [
      _c("i", {
        staticClass: "fa-solid fa-cloud-arrow-up",
        staticStyle: { "font-size": "32px" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }